import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { currentTab } from '@/app/current-tab';
import { initSentry } from '@/app/sentry';
import packageJson from '../package.json';
import '@web-comp/core';
import '@web-comp/json-viewer';

// Voor de bootstrap, zodat ook opstartfouten gevangen worden
initSentry(environment);

const splashVersion = document.getElementById('splash-version');
if (splashVersion) {
  splashVersion.textContent = `v${packageJson.version}`;
}

if (environment.production) {
  enableProdMode();
}

// AOT: templates zijn al gecompileerd, de JIT-compiler van platformBrowserDynamic is overbodig
platformBrowser()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => console.error(err));

currentTab.logout$.subscribe(() => {
  window.location.reload();
});

currentTab.login$.subscribe(() => {
  window.location.reload();
});

window.onbeforeunload = () => {
  currentTab.destroy();
};
